import styled from 'styled-components'

const Loader = (): JSX.Element => {
  return (
    <StyledSpinner />
  )
}

export default Loader

export const StyledSpinner = styled.div`
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
  

  display: inline-block;
  width: 80px;
  height: 80px;

&:after {
  content: " ";
  display: block;
  width: 64px;
  height: 64px;
  margin: 8px;
  border-radius: 50%;
  border: 6px solid ${({ theme }) => theme.COLOR.PRIMARY_BLUE};
  border-color: ${({ theme }) => theme.COLOR.PRIMARY_BLUE} transparent ${({ theme }) => theme.COLOR.PRIMARY_BLUE} transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
`
